angular.module('picmonic-common').animation('.pls-animation-left-slide', [
  function () {
    return {
      addClass: function (element, className, doneFn) {
        gsap.to(element, {
          duration: 0.75,
          opacity: 1,
          left: 0,
          ease: Power4.easeOut,
          onComplete: doneFn,
        });
      },
      removeClass: function (element, className, doneFn) {
        gsap.to(element, { duration: 1, opacity: 0, onComplete: doneFn });
      },
    };
  },
]);
